import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpBackend } from '@angular/common/http';
import { environment } from '@environments/environment';
import {HttpProviderService} from '@shared/services/http/http-provider.service';

export class CustomerHttpService {

  constructor(private http: HttpClient,
              private providerPath: string) {
  }
  sendGetRequest(path: string, headers: HttpHeaders, params: HttpParams) {
    headers = headers.append('SkipInterceptor', '*');
    const requestOptions = {
      headers: headers,
      params: params,
      observe: 'response' as 'body',
    };
    return this.http.get(`${this.providerPath}${path}`, requestOptions);
  }
  sendPostRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    headers = headers.append('SkipInterceptor', '*');
    const requestOptions = {
      headers: headers,
      observe: 'response' as 'body',
      params: params
    };
    return this.http.post(`${this.providerPath}${path}`, body, requestOptions);
  }
  sendPatchRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    headers = headers.append('SkipInterceptor', '*');
    const requestOptions = {
      headers: headers,
      observe: 'response' as 'body',
      params: params
    };
    return this.http.patch(`${this.providerPath}${path}`, body, requestOptions);
  }
  sendPutRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    headers = headers.append('SkipInterceptor', '*');
    const requestOptions = {
      headers: headers,
      observe: 'response' as 'body',
      params: params
    };
    return this.http.put(`${this.providerPath}${path}`, body, requestOptions);
  }
  sendDeleteRequest(path: string, headers: HttpHeaders, params: HttpParams) {
    headers = headers.append('SkipInterceptor', '*');
    const requestOptions = {
      headers: headers,
      observe: 'response' as 'body',
      params: params
    };
    return this.http.delete(`${this.providerPath}${path}`, requestOptions);
  }
}


@Injectable({
  providedIn: 'root'
})
export class CustomerRequestProviderService extends CustomerHttpService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL + '/request/service-request');
  }
}

@Injectable({
  providedIn: 'root'
})
export class ApiHttpService extends CustomerHttpService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL + '/request');
  }
}

@Injectable({
  providedIn: 'root'
})
export class CbmRatingHttp extends CustomerHttpService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL + '/request');
  }
}

@Injectable({
  providedIn: 'root'
})
export class CbmHttp extends CustomerHttpService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL + '/request');
  }
}

@Injectable({
  providedIn: 'root'
})
export class CustomerHTTP extends CustomerHttpService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL + '/request/customer');
  }
}
@Injectable({
  providedIn: 'root'
})
export class PasswordExpiredHttp extends CustomerHttpService {
  constructor(private providerHttp: HttpClient) {
    super(providerHttp, environment.hostURL + '/request/passwordexpired');
  }
}





